import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import 'typeface-open-sans'; //eslint-disable-line
import 'typeface-lato'; //eslint-disable-line

import 'font-awesome/scss/font-awesome.scss';

import '../styles/index.css';
import '../styles/page.css';

import Header from '../components/header';

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Dust.Bit.Games - interactive media developer"
      meta={[
        { name: 'description', content: `Dust.Bit.Games / Christoph Grossegger
          is an interactive media, full-stack development and consulting company from Vienna, Austria.` },
        { name: 'keywords', content: `interactive media developer, game developer, full-stack developer, 
          consulting, unreal engine, unity, react, react-native, ios, android` },
      ]}
    />
    <div className="site-wrapper">
      <Header />

      <main>
        {children()}
      </main>
    </div>
  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func.isRequired,
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.jsx